<div class="card w-full h-full flex flex-col shadow-sm p-8 rounded-2xl bg-white gap-8">
  <div class="flex flex-row flex-wrap justify-between items-center gap-4">
    <div class="flex flex-col">
      <h1 class="font-semibold text-2xl">
        Productos
      </h1>
    </div>
    <div class="flex flex-row flex-wrap gap-3">
      <app-button
        label="Descargar plantilla"
        icon="fi-rr-download"
        [disabled]="!productList.length"
        (clickButton)="downloadTemplate()">
      </app-button>
      <app-button
        label="Cargar Excel"
        icon="fi-rr-upload"
        color="green-500"
        (clickButton)="productFileInput.click()">
      </app-button>
      <input
        #productFileInput
        type="file"
        accept=".xlsx"
        class="hidden"
        (change)="onProductFileSelected($event, productFileInput)">
      @if (massiveLoadErrors.length > 0) {
        <app-button
          [label]="'Ver errores (' + totalMassiveLoadErrors + ')'"
          icon="fi-rr-exclamation"
          color="red-500"
          (clickButton)="showMassiveLoadErrors = !showMassiveLoadErrors">
        </app-button>
      }
    </div>
  </div>
  <div class="flex flex-row flex-wrap justify-start gap-4">
    <app-custom-input [(value)]="product" placeholder="Buscar productos..."
      (enter)="(product?.length ?? 0) >= 2 ? onPageChange({ page: 0, first: 0, rows: 10 }) : null">
    </app-custom-input>
    <app-button label="Buscar" (clickButton)="onPageChange({ page: 0, first: 0, rows: 10 })"
      [disabled]="(product?.length ?? 0) < 2"></app-button>
    <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
  </div>

  @if (showMassiveLoadErrors && massiveLoadErrors.length > 0) {
    <app-massive-load-errors
      [errors]="massiveLoadErrors"
      [totalErrors]="totalMassiveLoadErrors"
      entityType="PRODUCT">
    </app-massive-load-errors>
  }

  <div class="overflow-x-auto">

    @if (productList && productList.length > 0) {
    <div class="card">
      <p-table [value]="productList" [paginator]="true" [rows]="rows" [first]="first" [lazy]="true"
        [lazyLoadOnInit]="false" (onLazyLoad)="loadProducts($event)" [totalRecords]="totalItems" [sortField]="sortField" [sortOrder]="sortOrder"
        [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
        [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template #header>
          <tr>
            <th pSortableColumn="id" class="px-4 py-2 text-left font-semibold text-base gap-2">ID <p-sortIcon
                field="id"></p-sortIcon></th>
            <th pSortableColumn="category" class="px-4 py-2 text-left font-semibold text-base gap-2">Categoría
              <p-sortIcon field="category"></p-sortIcon>
            </th>
            <th pSortableColumn="productType" class="px-4 py-2 text-left font-semibold text-base gap-2">Tipo de Producto
              <p-sortIcon field="productType"></p-sortIcon>
            </th>
            <th pSortableColumn="finish" class="px-4 py-2 text-left font-semibold text-base gap-2">Acabado <p-sortIcon
                field="finish"></p-sortIcon></th>
            <th pSortableColumn="name" class="px-4 py-2 text-left font-semibold text-base gap-2">Nombre <p-sortIcon
                field="name"></p-sortIcon></th>
            <th pSortableColumn="description" class="px-4 py-2 text-left font-semibold text-base gap-2">Descripción
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="usesAndApplications" class="px-4 py-2 text-left font-semibold text-base gap-2">Uso y
              aplicaciones <p-sortIcon field="usesAndApplications"></p-sortIcon></th>
            <th pSortableColumn="design" class="px-4 py-2 text-left font-semibold text-base gap-2">Diseño <p-sortIcon
                field="design"></p-sortIcon></th>
            <th pSortableColumn="keywords" class="px-4 py-2 text-left font-semibold text-base gap-2">Palabras clave
              <p-sortIcon field="keywords"></p-sortIcon>
            </th>
            <th pSortableColumn="active" class="px-4 py-2 text-left font-semibold text-base gap-2">Activo <p-sortIcon
                field="active"></p-sortIcon></th>
            <th class="px-4 py-2 text-left font-semibold text-base gap-2">Acción</th>
          </tr>
        </ng-template>
        <ng-template #body let-productList>
          <tr class="hover:bg-orange-50  ">
            <td class="px-6 py-4">{{ productList.id }}</td>
            <td class="px-6 py-4">{{ productList.category }}</td>
            <td class="px-6 py-4">{{ productList.productType }}</td>
            <td class="px-6 py-4">{{ productList.finish }}</td>
            <td class="px-6 py-4">{{ productList.name }}</td>
            <td class="px-6 py-4 max-w-[200px] truncate" [title]="productList.description">{{ productList.description }}
            </td>
            <td class="px-6 py-4 max-w-[200px] truncate" [title]="productList.usesAndApplications">{{
              productList.usesAndApplications }}</td>
            <td class="px-6 py-4 max-w-[200px] truncate" [title]="productList.design">{{ productList.design }}</td>
            <td class="px-6 py-4 max-w-[200px] truncate" [title]="productList.keywords">{{ productList.keywords }}</td>
            <td class="px-6 py-4">
              <span class="inline-flex px-3 py-1 text-xs font-medium rounded-xl"
                [ngClass]="getBackgroundClasses(productList.active)">
                {{ productList.active }}
              </span>
            </td>
            <td class="px-6 py-4">

              <div class="text-gray-400 flex flex-row gap-1">
                <i class="fi fi-rr-pencil flex text-2xl text-blue-300 cursor-pointer hover:text-blue-700"
                  title="Editar" (click)="openEditModal(productList.id)"></i>
                @if (productList.active) {
                <i class="fi fi-rr-toggle-on flex text-2xl text-green-500 cursor-pointer hover:text-green-700"
                  title="Desactivar" 
                  (click)="openActivateProductModal(productList.name, productList.id)"></i>
                } @else {
                <i class="fi fi-rr-toggle-off flex text-2xl text-gray-400 cursor-pointer hover:text-gray-600"
                  title="Activar" 
                  (click)="openActivateProductModal(productList.name, productList.id, true)"></i>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    } @else {
    <div class="bg-yellow-100 p-4 rounded-2xl">
      No hay registros
    </div>
    }

  </div>
</div>
